import { useState } from "react";
import { IconCheck, IconCopy } from "../";

export function CopyButton({ text, callMode }: { text: string; callMode: boolean }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async (e: React.MouseEvent) => {
    e.stopPropagation();
    await navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <button
      onClick={handleCopy}
      className={`p-1.5 rounded transition-all ${
        copied
          ? "bg-teal-500/10 text-teal-600"
          : callMode
          ? "hover:bg-slate-700 text-slate-500 hover:text-slate-300"
          : "hover:bg-slate-100 text-slate-400 hover:text-slate-600"
      }`}
      title="Copy to clipboard"
    >
      {copied ? (
        <IconCheck className="w-4 h-4" />
      ) : (
        <IconCopy className="w-4 h-4" />
      )}
    </button>
  );
}